import { Box, Grid2 as Grid, List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import SavingsIcon from '@mui/icons-material/SavingsOutlined';
import VisibilityIcon from '@mui/icons-material/VisibilityOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUpOutlined';
import { useTranslation } from 'react-i18next';
import { Section } from '@/components/Section';
import { setting, usePublicContent } from './use-public-content';
import { useSectionCopy } from './use-section-copy';

const BADGES = [
  { key: 'proven', Icon: WorkspacePremiumIcon },
  { key: 'price', Icon: SavingsIcon },
  { key: 'transparency', Icon: VisibilityIcon },
  { key: 'fair', Icon: ThumbUpIcon },
] as const;

/** Credentials band — the flyer's "Erfahrung, die Vertrauen schafft". */
export function Trust() {
  const { t } = useTranslation();
  const { settings } = usePublicContent();
  const percent = setting(settings, 'company.savingsPercent', '40');
  const items = t('trust.items', { returnObjects: true }) as string[];
  const copy = useSectionCopy('trust', { eyebrow: t('trust.eyebrow'), title: t('trust.title') });

  return (
    <Section
      tone="inverted"
      image="/images/installer.webp"
      eyebrow={copy.eyebrow}
      title={copy.title}
      subtitle={copy.subtitle}
    >
      <Grid container spacing={{ xs: 5, md: 8 }}>
        <Grid size={{ xs: 12, sm: 5 }}>
          <List dense disablePadding>
            {items.map((item) => (
              <ListItem key={item} disableGutters sx={{ alignItems: 'flex-start', py: 0.75 }}>
                <ListItemIcon sx={{ minWidth: 30, mt: 0.35, color: 'inherit', opacity: 0.7 }}>
                  <CheckIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: 'body2' }} primary={item} />
              </ListItem>
            ))}
          </List>
        </Grid>

        <Grid size={{ xs: 12, sm: 7 }}>
          <Grid container spacing={3}>
            {BADGES.map(({ key, Icon }) => (
              <Grid key={key} size={{ xs: 12, sm: 6 }}>
                <Stack spacing={1.25}>
                  <Icon sx={{ fontSize: 26, opacity: 0.8 }} />
                  <Typography variant="h5" component="h3">
                    {t(`trust.${key}.title`)}
                  </Typography>
                  <Box sx={{ opacity: 0.7 }}>
                    <Typography variant="body2">{t(`trust.${key}.body`, { percent })}</Typography>
                  </Box>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Section>
  );
}
